import { InventorySlotType } from '@/data/enums'
import { AtlasEmbed, PantheonEmbed, PassivesEmbed, SkillPriorityGroup, SkillsEmbed } from './embed'
import { Item } from './item'

export type PlayerClass = 'Str' | 'Dex' | 'Int' | 'StrDex' | 'StrInt' | 'DexInt' | 'StrDexInt'

export const defaultPlayerClass: PlayerClass = 'StrDexInt'

export type ItemId = number | undefined
export type ItemOrId = ItemId | Item

export type Author = {
  nickname: string
  image?: string
  customImageWidth?: number
  social?: {
    twitch?: string
    youtube?: string
    twitter?: string
    discord?: string
  }
}

export type StatPriority = {
  id: string
  rank: number
}

export type SkillRotation = { id: string; name: string; groups: SkillPriorityGroup[] }

export type EquipmentVariant = {
  id: string
  name?: string
  items: {
    [key in InventorySlotType]?: ItemId
  }
  priority?: {
    [key in InventorySlotType]?: StatPriority[]
  }
}

export type Profile = {
  class: PlayerClass
  ascendancy?: string

  level: number
  version: number

  equipment: {
    variants: EquipmentVariant[]
    active: number
  }

  mercenary: {
    variants: EquipmentVariant[]
    active: number
  }

  skills: Pick<SkillsEmbed, 'steps' | 'step'>

  passives: Pick<PassivesEmbed, 'variants' | 'active'>
  atlas: Pick<AtlasEmbed, 'variants' | 'active' | 'strategy'>
  pantheon: PantheonEmbed['active']

  showcaseVideo?: string
  relatedBuild?: string
  strAndWeak?: { strengths: string[]; weaknesses: string[] }
  author?: { contentCreator?: string; user?: Author }
  skillRotations?: SkillRotation[]
  buildRating?: { ratings: Record<string, number> }
  lootfilterLinks?: { name?: string; link?: string }[]
  bandits?: string
  pobProfileId?: string

  notes?: any
  changelog?: any
}

export type ItemLocation = ({ profile: number } | { embed: number }) & {
  type: 'items'
  slot: InventorySlotType
}

export type ItemEditing =
  | {
      type: 'item'
      item: number
    }
  | {
      type: 'slot'
      slot: InventorySlotType
    }

export type PobConfigSet = {
  placeholder: Record<string, string | number | boolean>
  input: Record<string, string | number | boolean>
}

export type PobBuild = {
  code: string
  stats: Record<string, number>
  config: PobConfigSet[]
  configSummary: {
    combatList: string[]
    buffList: string[]
    curseList: string[]
  }
  activeSkill: {
    skillSet?: number
    skillGem?: number
    skillCalcs?: number
    skillPart?: number
  }
  notes?: string
}
